import { Device, DeviceInfo } from '@capacitor/device';

export enum Platform {
  WEB = 'web',
  ANDROID = 'android',
  IOS = 'ios',
}

export const getDevice = async (): Promise<DeviceInfo> => {
  return await Device.getInfo();
};

export const getPlatform = async (): Promise<Platform> =>
  (await getDevice()).platform as Platform;

export const getModelName = async (): Promise<string> =>
  (await getDevice()).name ?? 'Unknown';

export const isBrowser = async (): Promise<boolean> =>
  (await getDevice()).platform === Platform.WEB;

export const isAndroid = async (): Promise<boolean> =>
  (await getDevice()).platform === Platform.ANDROID;

export const isIOs = async (): Promise<boolean> =>
  (await getDevice()).platform === Platform.IOS;

export const getDeviceId = async (): Promise<string> => {
  if (await isBrowser()) {
    const key = 'freedom_device_id';
    let id = localStorage.getItem(key);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(key, id);
    }
    return id;
  }

  const { identifier } = await Device.getId();
  return identifier;
};
